import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

const ConfirmContext = createContext(null);

const defaultDialog = {
  isOpen: false,
  title: 'Confirmer',
  message: '',
  confirmText: 'Confirmer',
  cancelText: 'Annuler',
  variant: 'danger',
};

export const ConfirmProvider = ({ children }) => {
  const [dialog, setDialog] = useState(defaultDialog);
  const resolverRef = useRef(null);

  const confirm = useCallback((options = {}) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setDialog({
        isOpen: true,
        title: options.title ?? 'Confirmer',
        message: options.message ?? '',
        confirmText: options.confirmText ?? 'Confirmer',
        cancelText: options.cancelText ?? 'Annuler',
        variant: options.variant ?? 'danger',
      });
    });
  }, []);

  const finish = useCallback((result) => {
    if (!resolverRef.current) return;
    const resolve = resolverRef.current;
    resolverRef.current = null;
    setDialog((prev) => ({ ...prev, isOpen: false }));
    resolve(result);
  }, []);

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <ConfirmDialog
        isOpen={dialog.isOpen}
        title={dialog.title}
        message={dialog.message}
        confirmText={dialog.confirmText}
        cancelText={dialog.cancelText}
        variant={dialog.variant}
        onClose={() => finish(false)}
        onConfirm={() => finish(true)}
      />
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }
  return ctx;
};
